import Page from "../../layout/Page";

import {useTranslation} from "react-i18next";
import usePagination from "../../util/usePagination";
import userService from "../../service/UserService";
import {DataTable} from "../../components/DataTable";
import Container from '@mui/material/Container';
import ListPageActions from "../../components/ListPageActions";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import AddButton from "../../ui/AddButton";
import applicationService from "../../service/ApplicationService";
import DeleteDialog from "../../components/DeleteDialog";

const UserListPage = ({title, ...props}) => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [selected, setSelected] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const columns = [
        {
            name: "name",
            label: t('label.name'),
            searchable: true
        },
        {
            name: "surname",
            label: t('label.surname'),
            searchable: true
        },
        {
            name: "email",
            label: t('label.email'),
            searchable: true
        },
        {
            name: "roles",
            label: t('label.roles'),
            execute: (roles) => roles?.map(role => role.name).join(", ")
        }
    ];

    const users = usePagination({
        service: userService
    })

    const ActionButtons = () => (
        <ListPageActions>
            <AddButton onClick={() => {
                navigate(`/users/create`)
            }}/>
        </ListPageActions>
    )

    return (
        <Page title={title}>
            <Container maxWidth={"lg"}>
                <ActionButtons/>
                <DataTable
                    title={t('title.userList')}
                    columns={columns} {...users}
                    onEdit={(item) => {
                        navigate(`/users/edit/${item._id}`);
                    }}
                    onDelete={(item) => {
                        setSelected(item);
                        setOpenDeleteDialog(true);
                    }}
                />
                <ActionButtons/>
            </Container>

            <DeleteDialog
                item={selected}
                itemService={applicationService}
                message={selected?.name}
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                    setSelected(null)
                }}
                onDoneCallback={users.search}
            />
        </Page>
    );
}

export default UserListPage;
